module.exports = __webpack_public_path__ + "img/惊讶.2a3adfe1.gif";